<script setup>
import About from "./About.vue";
import Contact from "./Contact.vue";
// import FAQ from "./FAQ.vue";
import Privacy from "./Privacy.vue";
import Terms from "./Terms.vue";

const { subPage, displayAlert, user, tagEvent, updatePage, autoHideNav } = defineProps({
	subPage: String,
	displayAlert: Function,
	user: Object,
	tagEvent: Function,
	updatePage: Function,
	autoHideNav: Boolean,
});
</script>

<template>
	<main class="column content">
		<About
			v-if="subPage === ''"
			:updatePage="updatePage"
			:autoHideNav="autoHideNav"
		/>
		<Contact
			v-if="subPage === 'contact'"
			:user="user"
			:tagEvent="tagEvent"
			:displayAlert="displayAlert"
		/>
		<FAQ v-if="subPage === 'faq'" />
		<Privacy v-if="subPage === 'privacy'" />
		<Terms v-if="subPage === 'terms'" />
	</main>
</template>

<style lang="scss" scoped>

</style>
